<template>
  <v-container v-if="!containerInitLoading && unit" fluid style="height: inherit">
    <v-row align="stretch" style="height: inherit;">
      <v-col style="max-width: 400px;">
        <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.details')" :item="unit"
          :saveMethod="saveChanges">
          <template v-slot:content="{ item, editMode, handleFocus }">
            <UnitEditContent :item="item" :editMode="editMode" :handleFocus="handleFocus">
            </UnitEditContent>
          </template>
        </EntityEditCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";
import UnitEditContent from "./UnitEditContent.vue";

export default {
  name: "ViewUnitInfo",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    EntityEditCard,
    UnitEditContent,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    async saveChanges(obj) {
      const dto = Object.assign({}, obj);
      await this.changeUnit(dto)
        .then((response) => {
          this.unit = response;
        })
        .catch((exception) => {
          console.error(exception);
        });
    },
  },

  computed: {
    unit: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },

  },

  watch: {

  },
};
</script>


<style lang='scss'></style>